import React, { useState, useEffect, useContext, useMemo } from 'react';
import { Row, Col, Table, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DeviceService, { DeviceItem } from '#/services/DeviceService';
import { Pagenate, PagenateData } from './parts/Pagenate';
import * as URI from 'urijs';
import { SpinnerView } from './parts/SpinnerView';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { UserContext } from './App';
import { PAGE_SIZE } from '#/config/constant';
import { FilterView } from './parts/FilterView';

dayjs.extend(utc);
dayjs.extend(timezone);

function Owner() {
  const ctx = useContext(UserContext);
  const service = new DeviceService('owner', ctx.userInfo!);
  const [devices, setDevices] = useState<DeviceItem[]>();
  const uri = new URI.default(window.location.href);
  const [page, setPage] = useState<PagenateData>({
    total: 0,
    page: Number(uri.query(true)['page'] || 0),
    size: PAGE_SIZE,
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setDevices(undefined);

    service
      .getList({
        ...page,
        ...uri.query(true),
      })
      .then(
        (res) => {
          setPage({
            ...page,
            ...res.page,
          });
          setDevices(res.data);
        },
        (e) => {
          if (e?.response.status === 401) {
            navigate(0);
          }
        }
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const items = useMemo(()=>{
    if (devices === undefined) {
      return [
        <tr key="spinner">
          <td colSpan={8}>
            <SpinnerView />
          </td>
        </tr>,
      ];
    } else if (devices.length > 0) {
      return devices.map((data: DeviceItem) => {
        const notify = [
          data.notify.sms_verifier ? 'SMS' : '',
          data.notify.email_verifier ? 'Mail' : '',
        ];

        return (
          <tr key={data.id}>
            <td>
              <Link to={`/owner/${data.id}`}>{data.id}</Link>
            </td>
            <td>{data.device_id}</td>
            <td>
              <Link to={`/child?owner_id=${data.owner_id}`}>{data.device_count}</Link>
            </td>
            <td>{dayjs.tz(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td>
              <Link to={`/admin/${data.admin_id}`}>{data.admin_id}</Link>
            </td>
            <td>{dayjs.tz(data.updated_at).format('YYYY-MM-DD HH:mm:ss')}</td>
            <td>{data.sensor?.receive_at ? dayjs.tz(data.sensor.receive_at).format('YYYY-MM-DD HH:mm:ss') : ''}</td>
            <td>
              {data.location.lon} / {data.location.lat}
            </td>
            <td>{notify.join(' / ')}</td>
          </tr>
        );
      });
    } else {
      return [
        <tr key="no-data">
          <td colSpan={8}>データがありません</td>
        </tr>,
      ];
    }
  }, [devices]);

  const addButton =
    ctx.userInfo && ctx.userInfo.role === 'superuser' ? (
      <Button variant="primary" href="/owner/modify" className="w-50">
        登録
      </Button>
    ) : (
      <></>
    );

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-4">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <FilterView
                  admin_id={ctx.userInfo && ctx.userInfo.role === 'superuser' ? true : false}
                  device_id={true}
                  date_range={'設置日'}
                  id={true}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <Pagenate {...page} />
              </Col>
              <Col className="text-end">{addButton}</Col>
            </Row>
            <Row className="mt-3 border">
              <Col className="p-2">
                <div className="overflow-scroll">
                  <Table className="mb-0">
                    <thead>
                      <tr>
                        <th>親機ID</th>
                        <th>識別ID</th>
                        <th>子機数</th>
                        <th>設置日</th>
                        <th>管理者</th>
                        <th>最終更新日</th>
                        <th>最新センサー更新日</th>
                        <th>設置位置</th>
                        <th>お知らせ設定</th>
                      </tr>
                    </thead>
                    <tbody>{items}</tbody>
                  </Table>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default Owner;
